import httpClient from './_httpClient';

function endPoint(scopeId, languageId = null) {
  let endPoint = "/scopes";
  languageId ? endPoint+="/" + scopeId+'/languages/'+languageId+'/help' : endPoint+="/" + scopeId+'/help'

  return endPoint;
}

const getScopeLanguagesWithDefaultHelp = (scope_id) => httpClient.get(endPoint(scope_id));
const getScopeLanguageHelpContent = (scope_id, language_id) => httpClient.get(endPoint(scope_id, language_id));
const updateScopeHelpContent = (scope_id, help_id, help) => httpClient.put("/scopes/" + scope_id + "/help/" + help_id, {help_content: help});

export {
  getScopeLanguagesWithDefaultHelp,
  getScopeLanguageHelpContent,
  updateScopeHelpContent
}
